import { Link } from "react-router-dom";
import { liveItems } from "@/mocks/lives";
import { formatViewers, getCategoryLabel } from "@/utils/live";

export default function LiveNowStrip() {
  const nowLive = liveItems.filter((item) => item.status === "live");

  return (
    <section className="w-full border-y border-background-200/60 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-6 md:py-10">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-live-line text-sm" />
            </span>
            正在直播
          </h2>
          <Link
            to="/channels"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 transition-colors hover:text-primary-200"
          >
            更多直播
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="no-scrollbar flex snap-x gap-4 overflow-x-auto pb-1">
          {nowLive.map((item) => (
            <Link
              key={item.id}
              to={`/live/${item.id}`}
              className="group flex w-[260px] shrink-0 snap-start items-center gap-3 rounded-lg border border-background-200/60 bg-background-100 p-3 transition-colors hover:border-primary-500/60"
            >
              <div className="relative h-14 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.streamer} 直播 ${item.title}`}
                  title={`${item.title} - 360直播`}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-300">
                  {item.title}
                </p>
                <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="truncate">{item.streamer}</span>
                  <span className="flex items-center gap-1 text-accent-400">
                    <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-live-pulse" />
                    {formatViewers(item.viewers)}
                  </span>
                </div>
                <span className="mt-1 inline-block text-[11px] text-secondary-900">
                  {getCategoryLabel(item.category)}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}